import instance from '../instance';
import {RequestSubscriptionsResult} from './types';

export const fetchSubscriptions = () =>
  instance.get<RequestSubscriptionsResult>(`/frontend/api/v1/digest/subscriptions`);

export const requestSubscriptionDelete = (token: string) =>
  instance.post('/frontend/api/v1/digest/unsubscribe', {token});

export const requestChangeSubscriptionFrequency = (id: string, schedule: string) =>
  instance.put(`/frontend/api/v1/digest/subscriptions/${id}`, {schedule});
